import React from "react";
import { Loader, LoaderSize, LoaderType } from "components/common/Loader.component";


export const ImageLoading = (): React.ReactElement => {
    return (
        <div className={"page_container"}>
            <div className="attachment-image-container__loading-spinner position-absolute">
                        <Loader type={LoaderType.Default} size={LoaderSize.Medium} role="status" ariaHidden={false}/>
            </div>
        </div>
    )
}

export default ImageLoading;